/* eslint-disable comma-dangle */
/* eslint-disable semi */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { API_URL } from "../configs/apiConfig";

// Async thunk for admin login
export const logIn = createAsyncThunk(
  "login/admin",
  async (adminData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/admin/login`, adminData, {
        headers: {
          Accept: "application/json",
        },
      });
      console.log(response.data.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Network error occurred");
    }
  }
);

// Initial state
const initialState = {
  admin: null, // Stores authenticated admin user data
  loading: false, // Tracks API request loading state
  error: null, // Stores any error messages
};

// Login slice
const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(logIn.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(logIn.fulfilled, (state, action) => {
        state.loading = false;
        state.admin = action.payload;

        // Store token in localStorage if it exists
        if (action.payload?.data.token) {
          localStorage.setItem("adminToken", action.payload.data.token);
        }
      })
      .addCase(logIn.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "حدث خطأ في تسجيل الدخول";
      });
  },
});

// Export actions

// Export reducer
export default loginSlice.reducer;
